<template>
  <v-row justify="center">
    <v-dialog
      @keydown.esc="closeModal()"
      max-width="500px"
      :value="isVisible"
      v-on:click:outside="closeModal"
      overlay-opacity="1"
      transition="slide-y-transition"
    >
      <v-card flat tile elevation="0">
        <v-toolbar
          class="black--text d-flex justify-center"
          color="#fbc501"
          tile
        >
          <v-toolbar-title>Katalog produktów</v-toolbar-title>
        </v-toolbar>
        <v-card-actions class="bold pt-5 d-flex flex-column">
          <YellowButton
            @click.native="downloadCatalogue()"
            class="mb-5"
            width="60%"
            text="Pobierz"
          />
          <YellowButton
            class="mb-5"
            width="60%"
            text="Wyślij"
            @click.native="sendCatalogueModal = true"
          />
          <YellowButton
            :href="getURL()"
            target="_blank"
            class="mb-5"
            text="Podgląd"
            width="60%"
          />
          <YellowButton
            text="Udostępnij"
            :disabled="!webShareApiSupported"
            icon="share"
            iconColor="white"
            width="60%"
            class="mb-5"
            @click.native="share()"
          />
          <small v-if="!webShareApiSupported" class="mt-2 text-center w-80">
            Przycisk udostępnij jest kompatybilny z przeglądarkami: Edge,
            Safari. Kompatybilność z przeglądarkami mobile: Chrome Andriod,
            Firefox Android, Opera Android, Safari iOS, Samsung Internet"</small
          >
        </v-card-actions>
        <BlackButton
          fab
          small
          icon="times"
          iconMargin=""
          class="close"
          @click.native="closeModal()"
        />
      </v-card>
    </v-dialog>
    <SendCatalogueModal
      :isVisible="sendCatalogueModal"
      @closeModal="sendCatalogueModal = false"
    />
  </v-row>
</template>

<script>
import BlackButton from "../buttons/BlackButton";
import YellowButton from "../buttons/YellowButton";
import SendCatalogueModal from "../modals/SendCatalogueModal";
import { URL } from "../../config";
import moment from "moment";
export default {
  name: "ProductCatalogueModal",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BlackButton,
    YellowButton,
    SendCatalogueModal,
  },
  data: () => ({
    sendCatalogueModal: false,
  }),
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
  },
  methods: {
    async share() {
      if (navigator.share) {
        try {
          const url = this.getURL();
          console.log({ url });
          await navigator.share({
            title: "Katalog produktów - ForMYever Office",
            text: "Dzień dobry,\nW załączonym linku znajduje się katalog produktów.\n\nPozdrawiam",
            url,
          });
        } catch (error) {
          // this.shareSnackbar();
        }
      } else {
        this.shareSnackbar();
      }
    },

    getURL() {
      return URL + `/assets/KatalogProduktow${moment().get("year")}.pdf`;
    },
    async downloadCatalogue() {
      await this.$store.dispatch("catalogue/downloadCatalogue");
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
<style lang="scss" scoped>
.outlined-form-section {
  position: relative;

  border-color: rgba(0, 0, 0, 0.38);
  border-width: 2px;
}

.outlined-form-section-title {
  top: -15px;
  left: 10px;
  position: absolute;

  padding: 0.2rem 0.5rem;

  background-color: white;

  font-size: 12px;
}
// .v-overlay__scrim {
//   backdrop-filter: blur(5px) !important;
//   background-color: transparent !important;
// }
.close {
  position: absolute;
  top: 2%;
  right: 1%;
  z-index: 10000000;
}
.noSelect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>
